import { Observable } from 'rxjs';

import { Report, ReportQueryParams } from '../models/report.model';
import { ListResponse } from '../models/utility.model';

export abstract class ReportGateway {
  abstract listReports(params: ReportQueryParams): Observable<ListResponse<Report>>;
  abstract getReport(projectId: string, version: number): Observable<{ url: string }>;
}
